import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import TotemButton from "../../components/TotemButton/TotemButton";
import TotemOption from "../../components/TotemOption/TotemOption";

import { UserStore } from "../../../../stores/UserStore/UserStore";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { PAGES } from "../../../../stores/LaundryStore/LaundryStore.types";
import { LaundryStore, setPage, setSelectedLaundryMachine, setSelectedLaundryType } from "../../../../stores/LaundryStore/LaundryStore";
import { LaundryMachineOption, LaundryTypeOption } from "../../../../types/laundry.types";
import { fetchLaundryMachinesEffect } from "../../../../stores/LaundryStore/LaundryStore.effects";
import { LaundryMachinesContainer, NoLaundryMachines, NoStation } from "./ChooseLaundryMachineStyles";

interface BtnsProps {
  selected?: LaundryMachineOption;
  handleGoBack: () => void;
}

const Buttons = ({ selected, handleGoBack }: BtnsProps) => {
  const text = selected?.name ? "Continuar" : "Selecione uma opção";

  return (
    <>
      <TotemButton negative onClick={() => handleGoBack()} text="Voltar" />
    </>
  );
};

const ChooseLaundryType: React.FC = () => {
  const { laundryMachineOptions, selectedLaundryMachine, selectedLaundryType } = useUnit(LaundryStore);
  const { station } = useUnit(UserStore);

  useEffect(() => {
    handleGetLaundryMachines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetLaundryMachines = () => {
    if (!station) {
      return;
    }

    setLoading(true);

    fetchLaundryMachinesEffect({ code: station, type: selectedLaundryType.type }).finally(() => {
      setLoading(false);
    });
  };

  const handleNextStep = () => {
    setPage(PAGES.LAUNDRY_PAYMENT);
  };

  const handleGoBack = () => {
    setPage(PAGES.CHOOSE_LAUNDRY_TYPE);
  };

  const renderSection = (laundryTypes: LaundryMachineOption[]) => {
    if (!laundryTypes.length) return null;

    return (
      laundryTypes.map((laundryMachine) => {
        //const isselected = selectedLaundryMachine?.id === laundryMachine.id;

        return (
          <TotemOption
            key={laundryMachine.id}
            title={laundryMachine?.name}
            subtitle={selectedLaundryType.name}
            isselected={false}
            //isselected={isselected}
            execSelection={() => {
              setSelectedLaundryMachine(laundryMachine)
              handleNextStep();
            }}
          />
        );
      })
    );
  };

  const renderLaundryMachines = () => {
    if (!station) {
      return (
        <NoStation>
          <p>Usuário sem estação, procure um atendente!</p>
        </NoStation>
      );
    }

    if (!laundryMachineOptions?.length)
      return (
        <NoLaundryMachines onClick={handleGetLaundryMachines}>
          <p>Nenhuma máquina disponível.</p>
          <p>Clique aqui para tentar novamente</p>
          <p> ou solicite ajuda a um atendente</p>
        </NoLaundryMachines>
      );

    return (
      <>
        {renderSection(laundryMachineOptions)}
      </>
    );
  };

  return (
    <TotemSkeleton
      title="Escolha uma Máquina"
      buttons={
        <Buttons
          selected={selectedLaundryMachine}
          handleGoBack={handleGoBack}
        />
      }
    >
      <LaundryMachinesContainer>{renderLaundryMachines()}</LaundryMachinesContainer>
    </TotemSkeleton>
  );
};

export default ChooseLaundryType;
